import React, {useCallback} from 'react';
import {oauthRedirect} from 'utils/oauthRedirect';
import {Stoplight} from '@components/integrations/Stoplight';

interface RecallZoomIntegrationCardProps {
  authURI: string | null;
  state: 'red' | 'green';
}

export const RecallZoomIntegrationCard: React.FC<RecallZoomIntegrationCardProps> = ({
  authURI,
  state,
}) => {
  const onClick = useCallback(() => {
    if (authURI) {
      // Can't call this meaningfully if authURI is null.
      oauthRedirect(authURI);
    }
  }, [authURI]);

  if (!!authURI) {
    // Integration is configured.
    return (
      <Stoplight
        name="ZoomNoteTaker"
        imageAltText="Mediafly Notetaker for Zoom"
        onClick={onClick}
        state={state}
      />
    );
  } else {
    // Integration is not configured for this account. Do not show the card.
    return null;
  }
};
